// src/com/dc_temp_break_his/DcTempBreakHisDict.js
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

/**
 * DC_TEMP_BREAK_HIS React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-12-05 13:44:39 using DbdbTap
 * https://www.dbdbtap.com
 */
export const DcTempBreakHisDictionary = {
    errorTitle: {
        Get: '온도관제 리스트 조회 오류',
    },
    tableProps: {
        tableId: 'dcTempBreakHisTable',
        uniqueKey: 'uniqueKey', // 데이터 조회 후 생성됨.
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            { id: 'dcName', label: '출발지', width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'storeName', label: '도착지', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'comName', label: '운송사', width: 150, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehPlates', label: '차량번호', width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'gpsTime', label: '최종추적시간', width: 100, show: true, option:{align: 'center', print:(r,i,v)=>v?v.substring(11):'-'} },
            { id: 'location', label: '최종위치', width: 300, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'breakTime', label: '이탈시간', width: 80, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'checkNo', label: '체크번호', width: 70, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'tempF', label: '전면', width: 60, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'tempM', label: '중면', width: 60, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'tempR', label: '후면', width: 60, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'resultTemp', label: '체크결과', width: 80, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            //print using getTableColumnOption(c,t,i)
            // { id: 'dcCd', label: Dict.dcCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            /* { id: 'storeId', label: Dict.storeId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'comId', label: Dict.comId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'gpsTime', label: Dict.gpsTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'vehInfoSeq', label: Dict.vehInfoSeq.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'regDate', label: "regDate", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'regUser', label: "regUser", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'tsrTemp', label: Dict.tsrTemp.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehTypeId', label: Dict.vehTypeId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehTypeName', label: Dict.vehTypeName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'note', label: Dict.note.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'tsrTempF', label: Dict.tsrTempF.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'tsrTempM', label: Dict.tsrTempM.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'tsrTempR', label: Dict.tsrTempR.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'transTypeCd', label: Dict.transTypeCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} }, */
        ]
    },
};
